import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=23c0f4de"
import script from "./DialogWrapper.vue?vue&type=script&lang=js"
export * from "./DialogWrapper.vue?vue&type=script&lang=js"
import style0 from "./DialogWrapper.vue?vue&type=style&index=0&id=23c0f4de&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports